import React from 'react';
import {Button, FormField} from 'components';
import {useField, useFocusPopup, openPopup} from 'helpers';

export function Dropdown({ Popup, children = label, inline, className, ...props}) {
  if (!inline) {
    const [ { value }, , { setValue } ] = useField(props);
    const popup = useFocusPopup(Popup, {
      ...props,
      value,
      setValue,
      deps: [ value ],
      className: 'adjacent'
    });
    return (
      <FormField {...props} {...popup} value={value} className={className}>
        { children(value) }
      </FormField>
    );
  }
  return (
    <Button className={['dropdown', className]} rightIcon="chevron" onClick={openPopup(Popup, props)} tagName="span">
      { children }
    </Button>
  );
}

function label(value) {
  return (
    <b>{ value }</b>
  );
}
